import { PLANS } from '../config/plans';
import { getUserData, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

/**
 * Read the user's plan key from their Firestore document.
 * Defaults to 'core' if the field is missing.
 */
export async function getUserPlan(uid) {
  try {
    const data = await getUserData(uid);
    return data?.plan || 'core';
  } catch {
    return 'core';
  }
}

/**
 * Return the full plan config object for a given plan key.
 */
export function getPlanConfig(planKey) {
  return PLANS[planKey] || PLANS.core;
}

/**
 * Return whether a specific feature is enabled for a given plan key.
 * Feature names match the boolean fields on the plan config objects.
 */
export function isFeatureEnabled(planKey, featureName) {
  const config = getPlanConfig(planKey);
  return !!config[featureName];
}

/**
 * Return whether an email is in the proWhitelist emails array.
 */
export function isWhitelisted(email, whitelistEmails) {
  if (!email || !Array.isArray(whitelistEmails)) return false;
  const emailLower = email.toLowerCase();
  return whitelistEmails.some(e => e.toLowerCase() === emailLower);
}

// ─── Operating cost config (client-side cache) ────────────────────────────────
let _cachedConfig = null;

/**
 * Fetch monthlyOperatingCost and leeway from config/settings.
 * Result is cached in module scope; call clearOperatingCostCache() to invalidate.
 */
export async function getOperatingCostConfig() {
  if (_cachedConfig) return _cachedConfig;
  try {
    const snap = await getDoc(doc(db, 'config', 'settings'));
    if (snap.exists()) {
      _cachedConfig = {
        monthlyOperatingCost: snap.data().monthlyOperatingCost ?? 40,
        leeway: snap.data().leeway ?? 1,
      };
    } else {
      _cachedConfig = { monthlyOperatingCost: 40, leeway: 1 };
    }
  } catch {
    _cachedConfig = { monthlyOperatingCost: 40, leeway: 1 };
  }
  return _cachedConfig;
}

export function clearOperatingCostCache() {
  _cachedConfig = null;
}
